export const teamsCharm_ariaLabel = "DyO69c";
export default {teamsCharm_ariaLabel};